import { useState, useCallback } from 'react';

export function useContextMenu(disabled: boolean = false) {
    const [anchorPosition, setAnchorPosition] = useState<{ top: number; left: number } | null>(null);

    const handleOpen = useCallback(
        (event: React.MouseEvent) => {
            event.preventDefault();
            event.stopPropagation();
            if (disabled) return;
            setAnchorPosition({
                top: event.clientY - 6,
                left: event.clientX + 2,
            });
        },
        [disabled]
    );

    const handleClose = useCallback(() => {
        setAnchorPosition(null);
    }, []);

    return {
        anchorPosition,
        isOpen: Boolean(anchorPosition),
        handleOpen,
        handleClose,
    };
}
